import { LocalizationSliceShape } from './reducer';

export const localizationLanguageCodeSelector = (state: LocalizationSliceShape) => state.localization.languageCode;
